import { ActionType, ComponentType } from '../../enums';

export interface CreateCheckoutErrorEventPayloadOptions {
  errors: {
    code: string;
    message: string | null | undefined;
  }[];
}

export interface CreateCheckoutErrorEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    errors: {
      id: string;
      message: string | null | undefined;
    }[];
  };
}

export const createCheckoutErrorEventPayload = ({
  errors,
}: CreateCheckoutErrorEventPayloadOptions): CreateCheckoutErrorEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.ERROR,
      component_type: ComponentType.CHECKOUT,
      errors: errors.map((error) => ({
        id: error.code,
        message: error.message,
      })),
    },
  };
};
